<template>
  <div >
    <form @submit.prevent="submitForm" class="nota-remision-form" id="form-print">
        <div class="header" id="header">
          <h2 style="margin: 0">Recibo Dinero</h2>
        </div>
    
        <div class="form-table">
          <div class="form-row">
          </div>
          <div class="form-row">
            <div class="form-cell" style="margin-right: 4px;">
              <label>
                <img src="@/assets/calendar.png" alt="Calendario" class="calendar-icon" style="width: 1rem;">
                Fecha:
              </label>
              <input type="date" v-model="notaRemision.fecha" required>
            </div>
            <div class="form-cell" style="margin-left: 4px;">
              <label>No. Recibo:</label>
              <input type="text" v-model="notaRemision.noRecibo" required style="color: red">
            </div>
          </div>
    
          <!-- Tercera Fila (Campo "Recibí de") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>Recibí de:</label>
              <input type="text" v-model="notaRemision.recibiDe" required>
            </div>
          </div>
    
          <!-- Cuarta Fila (Campo "La Cantidad de") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>La Cantidad de:</label>
              <input type="text" v-model="notaRemision.cantidadDe" required>
            </div>
          </div>
    
          <!-- Quinta Fila (Campo "Por Concepto de") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>Por Concepto de:</label>
              <input type="text" v-model="notaRemision.porConceptoDe" required>
            </div>
          </div>
    
          <!-- Sexta Fila (Campo "Nombre Completo") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>Nombre Completo:</label>
              <input type="text" v-model="notaRemision.nombreCompleto" required>
            </div>
          </div>
    
          <!-- Séptima Fila (Campo "Domicilio") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>Domicilio:</label>
              <input type="text" v-model="notaRemision.domicilio" required>
            </div>
          </div>
    
          <!-- Octava Fila (Campo "Ciudad") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>Ciudad:</label>
              <input type="text" v-model="notaRemision.ciudad" required>
            </div>
          </div>
    
          <!-- Novena Fila (Campo "Acreditarse a") -->
          <div class="form-row">
            <div class="form-cell-full">
              <label>Acreditarse a:</label>
              <input type="text" v-model="notaRemision.acreditarseA" required>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-cell radio-input">
            <input type="radio" id="efectivo" v-model="notaRemision.tipoPago" value="efectivo">
            <label for="efectivo">Efectivo</label>
          </div>
          <div class="form-cell radio-input">
            <input type="radio" id="tarjetaCredito" v-model="notaRemision.tipoPago" value="tarjetaCredito">
            <label for="tarjetaCredito">Tarjeta</label>
          </div>
          <div class="form-cell radio-input">
            <input type="radio" id="transferencia" v-model="notaRemision.tipoPago" value="transferencia">
            <label for="transferencia">Transferencia</label>
          </div>
          <div class="form-cell radio-input">
            <input type="radio" id="cheque" v-model="notaRemision.tipoPago" value="cheque">
            <label for="cheque">Cheque</label>
          </div>
        </div>    

        <div class="form-row hidden" id="firma-img">
          <div class="form-cell-full" v-if="signature_pad!=null">
            <label>Firma</label>
            <div style="text-align:center">
              <img :src="signature_pad.toDataURL()" style="width: 6cm; max-width: 85%;"/>
            </div>
          </div>
        </div>

        <div class="form-row" :class="{ hidden: printing }" id="firma-input">
          <div class="form-cell-full">
            <label>Firma</label>
            <div id="signature-container">
              <!--canvas id="signature-pad" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing"></canvas-->
              <canvas :class="{ 'bg-gray': !printing }" id="signature-pad"></canvas>
            </div>
            <button type="button" @click="clearSignature" style="margin-top: 8px; font-size: 1rem">Limpiar Firma</button>
          </div>
        </div>

    </form>

    <div :class="{ hidden: printing }" class="botones-acciones">
      <div style="display: flex; width: 800px; max-width: 100%; margin: 1rem auto;">
        <button class="boton-exportar" @click="exportarPDF" style="margin-right: 0.65rem; justify-content: center; align-items: center; display: flex; font-size: 1.15rem">
          <img src="@/assets/pdf.png" alt="Exportar a PDF" style="width: 1.5rem; margin-right: 1rem;"> EXPORTAR A PDF
        </button>
        <button class="boton-imprimir" @click="imprimir" style="margin-left: 0.65rem; justify-content: center; align-items: center; display: flex; font-size: 1.15rem">
          <img src="@/assets/print.png" alt="Imprimir" style="width: 1.5rem; margin-right: 1rem;"> IMPRIMIR RECIBO
        </button>
      </div>  
    </div>  

  </div> 
</template>
  

<script>
import html2pdf from 'html2pdf.js';
import SignaturePad from 'signature_pad';

export default {
  data() {
    return {

      notaRemision: {
        fecha: '',
        noRecibo: '',
        recibiDe: '',
        cantidadDe: '',
        porConceptoDe: '',
        nombreCompleto: '',
        domicilio: '',
        ciudad: '',
        acreditarseA: '',
        tipoPago: {
          efectivo: false,
          tarjetaCredito: false,
          transferencia: false,
          cheque: false
        },
      // Otros campos...
      },
      printing: false,
      signature_pad: null,
    };
  },
  methods: {

    submitForm() {
      this.$emit('submit', this.notaRemision);
    },

    exportarPDF() {
      this.printing =  true;

      var element = document.getElementById("firma-img");
      element.classList.remove("hidden");

      const html = document.getElementById('form-print');
      const opciones = {
        margin: 10,
        filename: 'recibo_dinero.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };
      html2pdf().from( html ).set(opciones).save().then( () =>{
        this.printing =  false;
        element.classList.add("hidden");
      });
    },

    imprimir() {
      this.printing =  true;
      setTimeout(() => {
        window.print();
        this.printing =  false;
      }, "250");
     },

    clearSignature() {
      this.signature_pad.clear();
    },

  },

  mounted() {

    const canvas = document.getElementById('signature-pad');

    const ctx = canvas.getContext('2d');

    canvas.style.width ='100%';
    canvas.style.height='100%';

    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    ctx.strokeStyle = '#000'; // Color del trazo
    ctx.lineWidth = 1; // Ancho del trazo
    ctx.lineCap = 'round'; // Forma del trazo
    ctx.lineJoin = 'round';

    this.signature_pad = new SignaturePad(canvas, {
      minWidth: 1,
      maxWidth: 2,
    });

  }  

}

</script>
  
<style scoped src="./style.css">  
</style>


<style type="text/css" media="print">

  /* aplica estilos solo al formato de impresión  */
  @media print {

    /* quitar encabezados y pie de página */
    @page  {
        size:  auto;
        margin: 0 !important;
    }

    /* HACER MAS COMPACTOS LOS CAMPOS */
    .form-cell-full {

    }

    .nota-remision-form {
      padding: 2px !important;
    }

    /** mantener colores y aplicar margnes a la hoja */
    body {
      print-color-adjust: exact; 
      padding: 6% !important;
      margin: auto;
    }

    /** colores del header */
    #form-print .header {
      color: #ffffff;
      background-color: #004f9e !important;
    }

    /** ocultar botones */
    .botones-acciones {
      display: none;
    }

    /** quitar borde del contenedor */
    .nota-remision-form {
      box-shadow: none !important;
    }

    /** tamaño del campo de firma */
    #firma-input {
      display: none !important;
    }

    /* quitar el color de fondo del area de firma */
    #signature-pad {
      background-color: transparent !important;
    }

    #firma-img {
      display: block !important;
    }


  }

</style>
